import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-progressbar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit {
    @Input() active?: any;
    steps = [
        'Νέα Αίτηση & Προβολή Αιτήσεων',
        'Πρόσκληση Συμβαλλομένων',
        'Έλεγχος & Επιβεβαίωση Δικαιολογητικών',
        'Υποβολή στο Κτηματολογιο',
        'Υποβλήθηκε'
    ];
    constructor() {}

    ngOnInit(): void {
        if (!this.active) {
            this.active = 4;
        }
    }
}
